import {
  CANCELLATION_POLICY_DAYS,
  PRIOR_TO_CHECK_IN_CANCELLATION_POLICIES,
  SEVEN_DAYS_BEFORE_CHECK_IN,
} from 'constants/cancellationPolicies'
import { OFFER_TYPE_ALWAYS_ON, OFFER_TYPE_HOTEL } from 'constants/offer'
import { dateDifference } from 'lib/datetime/dateUtils'

export const RESERVE_FOR_ZERO_MIN_DAYS = 23

const LPC_ELIGIBLE_RATE_PLAN_POLICIES = new Set<string>([
  'refundable',
  ...PRIOR_TO_CHECK_IN_CANCELLATION_POLICIES.filter((policyType) => {
    const freeCancellationDays = CANCELLATION_POLICY_DAYS[policyType as App.CancellationPolicyType]
    return freeCancellationDays !== undefined && freeCancellationDays >= SEVEN_DAYS_BEFORE_CHECK_IN
  }),
])

export function isLpcRatePlanEligibleForZeroReservation(
  policyType: App.CancellationPolicyType | undefined,
): boolean {
  if (!policyType) {
    return false
  }
  return LPC_ELIGIBLE_RATE_PLAN_POLICIES.has(policyType)
}

export function isPackageEligibleForZeroReservation(
  offer: App.AnyOffer,
  pkgReservable?: boolean,
  checkIn?: moment.Moment,
  ratePlanCancellationPolicyType?: App.CancellationPolicyType,
): boolean {
  if (offer.type === OFFER_TYPE_ALWAYS_ON) {
    const ratePlanEligible = ratePlanCancellationPolicyType !== undefined
      ? isLpcRatePlanEligibleForZeroReservation(ratePlanCancellationPolicyType)
      : !!pkgReservable
    if (!ratePlanEligible) {
      return false
    }
    const threshold = offer.reserveForZero?.minDays ?? RESERVE_FOR_ZERO_MIN_DAYS
    if (!checkIn) {
      return true
    }
    return dateDifference(checkIn.toDate()).days > threshold
  }

  if (offer.type !== OFFER_TYPE_HOTEL || !offer.reserveForZero) {
    return false
  }
  const threshold = offer.reserveForZero.minDays
  if (pkgReservable) {
    if (!checkIn) { return true } // It is still potentially eligible
    const diff = dateDifference(checkIn.toDate())
    return diff.days > threshold
  }
  return false
}
